import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const displayNames = {
  facebook: "Facebook",
  google: "Google",
  linkedin: "LinkedIn",
  link: "Link",
  medium: "Medium",
  salesforce: "Salesforce",
  twitter: "Twitter",
  radio: "Radio",
  email: "Email"
};
function IconSocial({
  className,
  containerClassName,
  type,
  inverse,
  assistiveText,
  size
}, context) {
  const {
    socialSprite,
    socialRoundSprite
  } = context;
  const spritePath = inverse ? socialSprite : socialRoundSprite;
  const defaultAssistiveText = assistiveText || displayNames[type];
  return /*#__PURE__*/React.createElement("span", {
    className: cx("slds-icon__container", containerClassName),
    title: defaultAssistiveText
  }, /*#__PURE__*/React.createElement("svg", {
    className: cx("slds-icon", {
      [`slds-icon_${size}`]: size !== "medium"
    }, "tds-icon-social", `tds-icon-social_${type}`, {
      "tds-icon-social_inverse": inverse
    }, className),
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: `${spritePath}#${type}`
  })), /*#__PURE__*/React.createElement("span", {
    className: "slds-assistive-text"
  }, defaultAssistiveText));
}
IconSocial.displayName = "IconSocial";
IconSocial.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  type: PropTypes.string,
  inverse: PropTypes.bool,
  assistiveText: PropTypes.string,
  size: PropTypes.string
};
IconSocial.defaultProps = {
  className: null,
  containerClassName: null,
  inverse: false,
  size: "medium",
  type: null,
  assistiveText: ""
};
IconSocial.contextTypes = {
  socialSprite: PropTypes.string,
  socialRoundSprite: PropTypes.string
};

export { IconSocial as default };
